import IconButton from '@mui/material/IconButton';
import customTooltipIcons from './customTooltipIcons';

export default ({
  id,
  onMouseDown,
  disabled,
  active
}: {
  active: boolean;
  disabled: boolean;
  id: string;
  onMouseDown: (e: React.MouseEvent) => void;
}) => {
  // icon name example in dictionary: "mui-rte-84f2ed00-53a5-4620-8bc4-034f66044275-alignLeftId-button"
  const customIcon = customTooltipIcons[id.split('-')[7].slice(0, -2)];

  return (
    <IconButton
      id={id}
      onMouseDown={onMouseDown}
      color={active ? 'primary' : 'default'}
      disabled={disabled}
    >
      {customIcon}
    </IconButton>
  );
};
